<template>
  <el-dialog
    :title="title"
    v-model="dialogVisible"
    :width="width"
    @closed="handleClose">
    <el-form
      :model="passwordForm"
      :rules="passwordRules"
      ref="formRef"
      label-width="100px">

      <el-form-item label="旧密码" prop="oldPassword">
        <el-input
          type="password"
          v-model="passwordForm.oldPassword"
          show-password
          placeholder="请输入旧密码"/>
      </el-form-item>

      <el-form-item label="新密码" prop="newPassword">
        <el-input
          type="password"
          v-model="passwordForm.newPassword"
          show-password
          placeholder="至少6位字符"/>
      </el-form-item>

      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input
          type="password"
          v-model="passwordForm.confirmPassword"
          show-password
          placeholder="请再次输入新密码"/>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button
        type="primary"
        @click="handleSubmit">确认修改</el-button>
    </template>
  </el-dialog>
</template>

<script>
import axios from 'axios'; // 引入 Axios

export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '修改密码'
    },
    width: {
      type: String,
      default: '90%' // 默认宽度为90%
    }
  },
  emits: ['update:modelValue', 'submit'],
  data() {
    const validateConfirm = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    };

    return {
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: '旧密码不能为空', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: validateConfirm, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  methods: {
    handleClose() {
      this.$refs.formRef.resetFields()
    },
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate()
        const res = await axios.put('/api/change_password', {
          old_password: this.passwordForm.oldPassword,
          new_password: this.passwordForm.newPassword
        }, {
          headers: {
            'Authorization': `Bearer ${this.$store.getters.token}`
          }
        });
        if (res.data.success) {
          this.$message.success('密码修改成功');
          this.dialogVisible = false; // 关闭对话框
        }
      } catch (err) {
        console.error('请求失败:', err.response?.data || err.message);
        this.$message.error(err.response?.data?.message || '修改失败');
      }
    }
  }
}
</script>

<style scoped>
.el-dialog {
  margin: 0 auto;
  width: 90%; /* 默认宽度 */
  max-width: 400px; /* 最大宽度 */
  border-radius: 10px; /* 圆角边框 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 阴影效果 */
}

.el-dialog__header {
  padding: 1rem;
  background-color: #f8f9fa; /* 浅灰色背景 */
  border-bottom: 1px solid #dee2e6; /* 分隔线 */
}

.el-dialog__title {
  font-size: 18px; /* 标题字体大小 */
  font-weight: 500; /* 标题字体加粗 */
}

.el-dialog__body {
  padding: 1rem;
}

.el-form {
  padding: 0;
}

.el-form-item {
  margin-bottom: 1rem;
}

.el-form-item__label {
  font-size: 14px; /* 标签字体大小 */
  color: #6c757d; /* 标签字体颜色 */
}

.el-input {
  width: 100%;
}

.el-input__inner {
  border-radius: 6px; /* 输入框圆角 */
  border: 1px solid #ced4da; /* 输入框边框 */
  padding: 0.5rem 1rem; /* 输入框内边距 */
}

.el-dialog__footer {
  padding: 1rem;
  text-align: right;
  background-color: #f8f9fa; /* 浅灰色背景 */
  border-top: 1px solid #dee2e6; /* 分隔线 */
}

.el-button {
  margin-left: 0.5rem;
  padding: 0.75rem 1.5rem; /* 按钮内边距 */
  border-radius: 6px; /* 按钮圆角 */
}

/* 响应式设计 */
@media (min-width: 768px) {
  .el-dialog {
    width: 30%; /* 在较大屏幕上恢复默认宽度 */
  }
}
</style>
